import Work1 from '../../assets/work1.png';
import Work2 from '../../assets/work-2.svg'
import Work3 from '../../assets/work3.png';
import Work4 from '../../assets/work4.png';
import Work5 from '../../assets/work5.png'
import Work6 from '../../assets/work6.png';
import Work7 from '../../assets/work7.svg'

const Menu = [
    {
      id: 1,
      image: Work1,
      title: "Portfolio Website",
      category: "FRONTEND",
      link1:"https://fahadkabali.netlify.app",
      link2:"https://github.com/fahadkabali/portfolio.git",
    },
    {
      id: 2,
      image: Work2,
      title: "Online Store",
      category: "BACKEND",
      link1:"https://online-store-ecommerce-frontend.netlify.app",
      link2: "https://github.com/fahadkabali/online-store-ecommerce-frontend.git",
    },
    {
      id: 3,
      image: Work3,
      title: "NFT Market Place",
      category: "WEB3",
      link1:"https://github.com/fahadkabali/token.git",
      link2: "https://github.com/fahadkabali/nft-marketplace.git",
    },
    
    {
      id: 4,
      image: Work4,
      title: "Keeper APP",
      category: "BACKEND",
      link1:"https://keeper-app-7b55e.web.app/",
      link2: "https://github.com/fahadkabali/keeper-app.git",
    },
    {
      id: 5,
      image: Work5,
      title: "Movie Search Site",
      category: "FRONTEND",
      link1:"https://fahadkabalimovies.web.app/",
      link2: "https://github.com/fahadkabali/movies.git",
    },
    
    {
      id: 6,
      image: Work6,
      title: "DApp Bank",
      category: "WEB3",
      link1:"https://github.com/fahadkabali/dbank.git",
      link2: "https://github.com/fahadkabali/dbank.git",
    },
    {
      id: 7,
      image: Work7,
      title: "Spur a prompt posting App",
      category: "FRONTEND",
      link1:"https://spur-theta.vercel.app/",
      link2: "https://github.com/fahadkabali/spur.git",
    },
    {
      id: 8,
      image: Work1,
      title: "Milima Security Website",
      category: "FRONTEND",
      link1:"https://milimasecurity.com/",
      link2: "https://github.com/fahadkabali",
    },
    {
      id: 9,
      image: Work2,
      title: "Cybersecurity Assessment Tool(CSAT)",
      category: "BACKEND",
      link1:"https://csat.milimasecurity.com/",
      link2: "https://github.com/fahadkabali/",
    }
  ];
  

export default Menu
